<template>
  <div class="container" v-if="this.datosRegistro != null">

    <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">
            <span v-if="this.datosRegistro.id==null">Registrar Nuevo Empleado</span>
            <span v-else>Editar Empleado</span>
          </div>
        </div>
      </div>
    </aside>

    <div class="row">

      <div class="col-12 fieldset-container mt-3">
        <span class="label-container">
          Datos del empleado
        </span>
        <div class="mt-3">
          <div class="row">
            <div class="col-4">
              <span class="text">Número Empleado:</span><br/>
              <input v-model="datosRegistro.numero_empleado" class="mt-2" type="text" placeholder="Número de empleado">
            </div>
            <div class="col-4">
              <span class="text">Nombre Empleado:</span><br/>
              <input v-model="datosRegistro.nombre_empleado" class="mt-2" type="text" placeholder="Nombre completo">
            </div>
            <div class="col-4">
              <span class="text">Correo:</span><br/>
              <input v-model="datosRegistro.correo_empleado" class="mt-2" type="text" placeholder="Correo del empleado">
            </div>
            <div class="col-4">
              <span class="text">Password:</span><br/>
              <div v-if="mostrarPass">
                <input v-model="datosRegistro.password" class="mt-2" placeholder="Contraseña">
                <button type="button" class="btn btn-success btn-sm"
                        @click="mostrarPass = false">
                  <FontAwesomeIcon :icon="faShow()"/>
                </button>
              </div>
              <div v-else>
                <input v-model="datosRegistro.password" class="mt-2" type="password" placeholder="Contraseña">
                <button type="button" class="btn btn-success btn-sm"
                        @click="mostrarPass = true">
                  <FontAwesomeIcon :icon="faHidden()"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="m-2"></div>

      <div class="col-12 fieldset-container">
        <span class="label-container">
          Lugares de trabajo del empleado
        </span>
        <div class="row">
          <div class="col-12" style="text-align: right">
            <button type="button" class="btn btn-success btn-sm"
                    @click="agregarLugar()">
              <FontAwesomeIcon :icon="faPlus()"/>
              Agregar Lugar
            </button>
          </div>
        </div>
        <div class="mt-3" v-if="datosRegistro.lugares_trabajo_form != null">
          <div class="row m-2 fieldset-container" v-for="(ltrabf, idx) in datosRegistro.lugares_trabajo_form" :key="ltrabf" >
            <div class="col-11">
              <empleados-area-turno-form-component :original="ltrabf"
                                                   :optionsCliente="optionsCliente" />
            </div>
            <div class="col-1" style="margin:auto;">
              <button class="btn btn-danger m-1"
                      @click="quitarLugar(idx)" title="Quitar">
                <FontAwesomeIcon :icon="faDesActivar()"/>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col" align="center">
        <button class="btn btn-success " @click="registrar()">Guardar</button>
      </div>
      <div class="col" align="center">
        <button class="btn btn-danger " @click="cancelar()">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {inject} from "vue";
import {AreaSucursalService} from "@/services/AreaSucursalService";
import {SucursalService} from "@/services/SucursalService";
import {EmpleadoService} from "@/services/EmpleadoService";
import {faEye, faEyeSlash, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import EmpleadosAreaTurnoFormComponent from "@/views/EmpleadosAreaTurnoForm-Component.vue";

export default {
  components: {EmpleadosAreaTurnoFormComponent, FontAwesomeIcon},
  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_EmpleadoCatService: new EmpleadoService(inject('$axios')),
      srv_AreaSucursalService: new AreaSucursalService(inject('$axios')),
      srv_SucursalService: new SucursalService(inject('$axios')),
    }
  },
  props: {
    original: Object,
    optionsCliente: Array
  },
  data() {
    return {
      datosRegistro: {
        id: null,
        nombre_empleado: null,
        numero_empleado: null,
        correo_empleado: null,
        password: null,
        lugares_trabajo_form: [],
      },
      mostrarPass: false
    }
  },
  async mounted() {
    if (this.original != null && this.original.id != null) {
      await this.obtener();
      this.cargaTotal = true;
    }
  },
  watch: {
    "datosRegistro.numero_empleado": {
      handler: function(newValue) {
        if (this.original == null || this.original.id == null) {
          if (newValue == null || String(newValue).trim().length === 0 ) {
            this.datosRegistro.correo_empleado = "";
          } else {
            this.datosRegistro.correo_empleado = newValue + "@jir.com"
          }
        }
      },
      deep: true
    }
  },
  methods: {
    faPlus() {
      return faPlus;
    },
    faDesActivar() {
      return faTrash;
    },
    faShow() {
      return faEye;
    },
    faHidden() {
      return faEyeSlash;
    },
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_EmpleadoCatService.obtener({
        numero_empleado: "" + this.original.numero_empleado,
        get_full: true
      }).then((response) => {
        if (response != null && response.length > 0) {
          this.datosRegistro = response[0];
        }
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async registrar() {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_EmpleadoCatService.cargar(this.datosRegistro).then((res) => {
        this.$swal(res.msj);
        this.cancelar();
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    cancelar() {
      this.$emit('_cancelarEditar');
    },
    agregarLugar() {
      if (this.datosRegistro.lugares_trabajo_form == null) {
        this.datosRegistro.lugares_trabajo_form = []
      }
      this.datosRegistro.lugares_trabajo_form.push({
        id_cliente: null,
        id_sucursal: null,
        ids_turno_area_sucursal: [],
        solo_supervisar: false
      })
    },
    quitarLugar(idx) {
      this.datosRegistro.lugares_trabajo_form.splice(idx, 1);
    }

  },
}
</script>

<style scoped>
.fieldset-container {
  border: #6c757d 1px solid;
  border-radius: 5px;
  padding: 10px;
}

.label-container {
  float: left;
  margin-top: -25px;
  margin-left: 1px;
  background: white;
}
</style>